import { create } from 'zustand';

const useFormsModalStore = create((set) => ({
  modal: { isOpen: false, type: '', data: null, size: 'lg', title: '' },
  setModal: (modal) => set({ modal: { ...modal, size: !modal?.size ? 'lg' : modal?.size } }),
  closeModal: () => {
    set({ modal: { isOpen: false, data: null, size: 'lg', title: '' } });
  },
}));

export default useFormsModalStore;
